import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./slices/cartSlice";
import wishlistReducer from "./slices/wishlistSlice";
import compareReducer from "./slices/compareSlice";
import filterReducer from "./slices/filterSlice";
import loyaltyModalReducer from "./slices/loyaltyModalSlice";

// Create a custom middleware for persisting state
const persistStateMiddleware = (store) => (next) => (action) => {
  // Call the next dispatch method in the middleware chain
  const result = next(action);

  // After the action has been processed, save the state to localStorage
  const state = store.getState();
  localStorage.setItem(
    "reduxState",
    JSON.stringify({
      cartData: state.cartData,
      wishlistData: state.wishlistData,
      compareData: state.compareData,
      filterData: state.filterData,
      loyaltyModalData: state.loyaltyModalData,
    }),
  );

  return result;
};

// Load state from localStorage
const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem("reduxState");
    if (!serializedState) return undefined;

    const savedState = JSON.parse(serializedState);
    return {
      cartData: savedState.cartData || [],
      wishlistData: savedState.wishlistData || [],
      compareData: savedState.compareData || [],
      filterData: savedState.filterData || {},
      loyaltyModalData: savedState.loyaltyModalData || false,
    };
  } catch (err) {
    console.error("Error loading state from localStorage:", err);
    return undefined;
  }
};

const preloadedState = loadStateFromLocalStorage();

const store = configureStore({
  reducer: {
    cartData: cartReducer,
    wishlistData: wishlistReducer,
    compareData: compareReducer,
    filterData: filterReducer,
    loyaltyModalData: loyaltyModalReducer,
  },
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(persistStateMiddleware),
});

export default store;
